import {Component, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Signin} from '../signin/signin';
import {RouterLink} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Shared} from '../services/shared';
import {firstValueFrom, Subscription} from 'rxjs';
import {AuthService} from '../services/auth';
import {TranslatePipe} from '@ngx-translate/core';

declare const bootstrap: any;
@Component({
  selector: 'app-navbar',
  imports: [Signin, RouterLink, TranslatePipe],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss'
})
export class Navbar implements OnInit, OnDestroy {
  env = environment;
  token = false;
  accessToken: string | null = '';
  plan = ''
  credits = 0
  renewPossible = true;
  http = inject(HttpClient)
  sharedService = inject(Shared)
  page = 'summarizer'

  private subscription!: Subscription;

  @ViewChild(Signin) signIn!: Signin;

  authService = inject(AuthService);
  private triedRefresh = false;


  ngOnInit() {

    this.authService.checkAuthOnStartup().subscribe((loggedIn) => {
      // console.log('Auth check complete, logged in:', loggedIn);
      if (loggedIn) {
        this.token = true
        this.doSomething()

      }
    });

    this.sharedService.registerNavbarFunction(this.doSomething.bind(this));
    this.subscription = this.sharedService.closeDropdown$.subscribe(() => {
      this.closeDropdown();
    });

  }

  async checkAndRefreshToken(): Promise<void> {
    const token = this.authService.getToken();
    if (!token) {
      // No token, user is logged out or just loaded
      this.token = false;
      return;
    }

    // Optional: decode token to check expiration
    if (this.isTokenExpired(token)) {
      try {
        await firstValueFrom(this.authService.refreshToken());
        this.token = true;
      } catch {
        this.token = false;
      }
    } else {
      this.token = true;
    }

  }

  isTokenExpired(token: string): boolean {
    try {
      const decoded = this.decodeJWT(token);
      if (!decoded || !decoded.exp) return true;
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp < now;
    } catch {
      return true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();

  }

  closeDropdown() {
    // console.log('in nvabar')
    const navbarCollapse = document.querySelector('#navbarNav');
    if (navbarCollapse) {
      const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
      if (bsCollapse) {
        bsCollapse.hide();
      } else {
        // Initialize and hide immediately if not instantiated yet
        const newCollapse = new bootstrap.Collapse(navbarCollapse, { toggle: false });
        newCollapse.hide();
      }
    }
  }

  doSomething() {
    // console.log('navbar get plan')
    this.getPlanAndCredits()
  }

  tokenChange() {
    this.token = true;
  }

  fixSignIn() {
    this.signIn.signUp = false;
    this.signIn.signUpMessageShow = false;
    this.signIn.signUpMessageShowSucceed = false;
    this.signIn.signUpMessageShowError = false;

    this.signIn.signInMessageShow = false;
    this.signIn.signInMessageShowSucceed = false;
    this.signIn.signInMessageShowError = false;
    this.signIn.resendConfirm = false;

    this.signIn.confirmMailError = '';
    this.signIn.confirmMailMessage = '';
    this.closeDropdown();

  }

  logout() {
    this.signIn.logout()
    this.token = false
    this.closeDropdown()
    // window.location.reload();
  }

  // Check if token is expired (assumes it's a JWT)
  // checkTokenExpiration(): boolean {
  //   const token = localStorage.getItem('accessToken');
  //   if (token === null) return true
  //   try {
  //     const decoded = this.decodeJWT(token);
  //     if (!decoded || !decoded.exp) return true;
  //     const now = Math.floor(Date.now() / 1000); // Current time in seconds
  //     // accesstoken < now ; false means valid
  //     return decoded.exp < now;
  //   } catch (error) {
  //     return true;
  //   }
  //
  // }

  // Decode JWT without verifying signature
  private decodeJWT(token: string): any {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    try {
      return JSON.parse(atob(parts[1]));
    } catch (error) {
      // console.error('Invalid JWT format:', error);
      return null;
    }
  }

  getPlanAndCredits() {
    const token = this.authService.getToken();
    const headers = token ? new HttpHeaders().set('Authorization', `Bearer ${token}`) : undefined;
    // console.log(token)
    if (token) {
      this.http.get<{ plan: string, credits: number }>(this.env.apiBaseUrl + '/plan-and-credits', { headers })
        .subscribe({
          next: data => {
            this.plan = this.capitalizeFirstLetter(data.plan);
            this.credits = data.credits;
            // console.log(this.plan)
          },
          error: err => {
            // console.error('API error', err);
          }
        });
    } else {
      this.plan = '';
      this.credits = 0;
    }
  }


  capitalizeFirstLetter(str: string): string {
    if (str === 'free') {
      str = '🔍 Explorer'
    }
    if (str === 'premium') {
      str = '🌱 Growth Member'
    }
    if (str === 'pro') {
      str = '🚀 Ultimate Member'
    }
    if (!str) return str;
    return str;
  }
}
